import React, { Component, Fragment } from 'react';
import { Form, Button, message, Modal, Radio, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EnterpriseForm from '../EnterpriseForm';
import ConfigurePlan from '../ConfigurePlan';
import { putExchange, postMembers, postContact, notificationExchange, setExchangePlan, getPrice } from '../../common/fetch';
import {
	CLOUD_ICON,
	// DIY_GREY_ICON,
	DIY_ICON,
	// ENTERPRISE_GREY_ICON,
	// BASIC_COIN_DROP,
	// PRO_COIN_DROP,
	// STANDARD_COIN_DROP,
	// EXCHANGE_GURU_DAN
} from '../../config/media';
import { getCookie } from '../../common/utils';
import { SetupAction } from '../../actions';
import { FormWrapper, ConfirmationWrapper } from './style';
import { Link } from 'react-router-dom';
import ExchangeGuru from './ExchangeGuru'

const { Item } = Form;

const RenderModalBody = ({
	form,
	isTypeWarning,
	is_enterprise,
	isPlanType,
	isMonthly,
	priceData,
	onSubmitEnterprise,
	onCancel,
	handleConfirm,
	handleToggle
}) => {
	if (isPlanType) {
		return (
			<ConfigurePlan
				isMonthly={isMonthly}
				priceData={priceData}
				handleToggle={handleToggle}
				handleClose={onCancel}
			/>
		);
	} else if (is_enterprise) {
		return (
			<EnterpriseForm form={form} onSubmitEnterprise={onSubmitEnterprise} />
		);
	} else if (isTypeWarning) {
		return (
			<Fragment>
				<div className="d-flex m-2">
					<div className="mt-1 mb-1">
						<img src={DIY_ICON} className="payment-icon" alt="payment" />
					</div>
					<div>
						<div className="mt-1 mb-1">
							<b className='do-it-title'>Do-it-yourself exchange</b>
							<div className="content-text-mini">This is for teams or tech savvy people that know their way around a server and can self-host their exchange. </div>
						</div>
						<div className="d-flex details-wrapper">
							<Icon type="exclamation-circle" className="detail-icon" />
							<div className="content-text-mini">
								<div className="detail-font-diy">DIY exchange requires technical capabilities.</div>
								<div>Are you sure you want to proceed with a DIY exchange setup?</div>
							</div>
						</div>
					</div>
				</div>
				<div className="btn-area">
					<Button block type="primary" onClick={onCancel}>
						Back
					</Button>
					<div className="separator"></div>
					<Button
						block
						type="primary"
						onClick={handleConfirm}
					>
						I understand. Proceed.
					</Button>
				</div>
			</Fragment>
		);
	} else {
		return (<div></div>);
	}
};

const ModalContent = Form.create({ name: 'EnterPrise' })(RenderModalBody);

class Hosting extends Component {
	state = {
		SERVER_TYPE: 'cloud',
		TECH_EMAIL: '',
		TECH_MEMBER: '',
		type: 'Cloud',
		is_confirm: false,
		isTypeWarning: false,
		is_enterprise: false,
		isOpen: false,
		planType: 'basic',
		isMonthly: false,
		priceData: {},
		is_fiatConfirm: false,
		display_content: '0',
		button_top: '-40px',
		setup: false,
		// is_setup:false,
		is_white: false,
		hostingCompleted: false,
		fiat_Dan:false,
		enterPriseFormData: {}
	};

	componentDidMount() {
		const { biz, tech } = this.props;
		this.setState({
			SERVER_TYPE: tech.SERVER_TYPE ? tech.SERVER_TYPE : this.state.SERVER_TYPE,
			TECH_EMAIL:
				biz.TECH_EMAIL !== '' && biz.TECH_EMAIL !== 'tech@bitholla.com'
					? 'tech-team'
					: biz.TECH_EMAIL,
			TECH_MEMBER: biz.TECH_EMAIL,
			type: tech.type ? tech.type : this.state.type
		});
		this.getExchangePrice();
		this.setPlan();
	}

	componentDidUpdate(prevProps) {
		const { tech, biz } = this.props;
		if (JSON.stringify(tech) !== JSON.stringify(prevProps.tech)) {
			this.setState({
				SERVER_TYPE: tech.SERVER_TYPE ? tech.SERVER_TYPE : this.state.SERVER_TYPE,
				type: tech.type ? tech.type : this.state.type
			});
		}
		if (JSON.stringify(biz) !== JSON.stringify(prevProps.biz)) {
			this.setPlan();
		}
		if (this.state.display_content === '0') {
			setTimeout(() => {
				this.setState({ button_top: "0px" });
			}, 1300);
			setTimeout(() => {
				this.setState({ display_content: "1" });
			}, 1500);
		}
	}

	getExchangePrice = async () => {
		try {
			const res = await getPrice();
			let priceData = {};
			Object.keys(res.data).forEach((key) => {
				let temp = res.data[key];
				if (!temp.month) {
					temp.month = {};
				}
				if (!temp.year) {
					temp.year = {};
				}
				priceData[key] = { ...temp };
			});
			this.setState({ priceData });
		} catch (error) {
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	}

	setPlan = () => {
		let planType = 'crypto';
		this.setState({ planType, type: 'Cloud' });
	};

	handleToggle = (value) => {
		this.setState({ isMonthly: value });
	};

	handleViewConfigure = () => {
		this.setState({ isOpen: true });
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { actions, biz } = this.props;
		const { SERVER_TYPE, TECH_EMAIL, TECH_MEMBER, type, planType, isMonthly } = this.state;
		if (!type || type === '') {
			message.info('You should choice the server type');
			return;
		}
		// if (tech.type === 'Cloud' && type === 'DIY' && !is_confirm) {
		// 	this.setState({ isTypeWarning: true });
		// 	return;
		// }
		// TODO check the email and server type
		try {
			const exchangeBody = {
				id: biz.id,
				info: {
					tech: { SERVER_TYPE },
					is_temp: false,
					is_completed: false,
				},
				type
			};
			// TECH_EMAIL 1. DIY("") 2. TECH_TEAM("tech-team") 3. tech@bitholla.com
			const email = TECH_EMAIL === 'tech-team' ? TECH_MEMBER : TECH_EMAIL;
			if (email === '' && TECH_EMAIL === 'tech-team') {
				message.info('You should input the your developer email');
				return;
			}
			if (biz.TECH_EMAIL !== email && email !== '') {
				// NOTE new Different Tech Email
				try {
					const body = {
						email,
					};
					await postMembers(biz.id, body);
				} catch (error) {
					console.error(error);
				}
			}

			if (type === 'Cloud') {
				try {
					const body = {
						email: 'tech@bitholla.com',
					};
					await postMembers(biz.id, body);
				} catch (error) {
					console.error(error);
				}
			}
			await putExchange(exchangeBody);
			if (type === 'Cloud') {
				const bodyParams = {
					id: biz.id,
					plan: planType,
					period: isMonthly ? 'month' : 'year'
				}
				try {
					await setExchangePlan(bodyParams);
				} catch (error) {
					if (error.data && error.data.message) {
						message.error(error.data.message);
					} else {
						message.error(error.message);
					}
				}
			}
			actions.updateTech({ SERVER_TYPE, MEMBER_MAIL: email, type });
			if (type === 'DIY') {
				this.onCancel();
				// this.props.onOk();
				// this.props.getExchange();
				await notificationExchange(biz.id);
				this.props.history.push('/dashboard');
			} else if (type === 'Cloud') {
				// await notificationExchange(exchangeBody.id);
				this.props.onOk(true);
				// this.props.setNewPay({ isNewPay: true });
				// this.props.history.push('/billing');
				// this.props.getExchange();
			}
			// if (planType === "fiat") {
			// 	this.onSubmitEnterprise()
				// this.props.history.push('/billing?fiatSetup=true');
			// }
			// this.openPaymentModal();
		} catch (error) {
			console.error(error);
			if (error.data && error.data.message) {
				message.error(error.data.message);
			} else {
				message.error('Failed to update setup configs');
			}
		}
	};

	// handleChange = (e) => {
	// 	const { name, value } = e.target;
	// 	this.setState({ [name]: value });
	// };

	onCancel = () => {
		this.setState({
			isTypeWarning: false,
			is_confirm: false,
			is_enterprise: false,
			is_fiatConfirm: false,
			isOpen: false
		});
	};

	handleConfirm = (e) => {
		this.onCancel();
		this.props.handleSetupSuccess();
		this.setState({ type: 'DIY' });
	};
	
	handleEnterprise = (formProps) =>{
		this.setState({enterPriseFormData:formProps , fiat_Dan: true, hostingCompleted: true });
		this.onCancel();
		this.props.handleSetupSuccess();
	}

	onSubmitEnterprise = async () => {
		const { biz } = this.props;
		const { enterPriseFormData } = this.state
		const data = {
			email: getCookie('email'),
			category: 'enterprise',
			subject: 'enterprise exchange',
			description: JSON.stringify(enterPriseFormData)
		};
		const exchangeBody = {
			id: biz.id,
			info: {
				// tech: { SERVER_TYPE: 'Enterprise' },
				is_temp: false,
				is_completed: false,
			},
			// type: 'Enterprise',
			business_info: enterPriseFormData
		};
		try {
			await putExchange(exchangeBody);
			const res = await postContact(data);
			await notificationExchange(this.props.biz.id);
			message.success(res.message);
			this.props.getExchange();
			this.props.history.push('/dashboard?fiatSetup=true');
		} catch (error) {
			this.onCancel();
			if (error && error.data && error.data.message) {
				message.error(error.data.message);
			} else {
				message.error('Fail to message');
			}
		}
	};

	handleChange = (event) => {
		this.setState({ planType: event.target.value });
	};

	handleExch = (e) => {
		// if(this.state.planType === 'fiat' && !this.state.fiat_Dan){
		// 	this.setState({ is_enterprise: true });
		// }
		// else {
			this.props.handleSetupSuccess(e);
			this.setState({ hostingCompleted: true });
		// }
	}

	handleSuccess =(e)=>{
		 this.handleSubmit(e)
	}

	render() {
		const {
			isTypeWarning,
			is_enterprise,
			planType,
			isOpen,
			isMonthly,
			priceData,
			is_fiatConfirm,
			button_top,
			// type
			// TECH_EMAIL,
			// TECH_MEMBER
		} = this.state;
		// const { moveToStep } = this.props;
		return (
			<FormWrapper>
				{!this.props.setup_Success ? <Form className="hosting-form">
					<Item className="description-wrapper hosting-wrapper" style={{marginTop:'49px'}}>
						<h3 className="head">Plan and Exchange Hosting Type</h3>
						<p className="mt-1 content-text-medium">Select if you will host your own exchange yourself or use Holla-cloud service.</p>

						<div className="my-2 d-flex">
							<div>
								<img src={CLOUD_ICON} className="payment-icon" alt="Cloud" />
							</div>
							<div>
								<h3 className="head">Allow HollaEx to host your exchange</h3>
								<p className="mt-1 content-text-small">Your exchange project will be hosted on Holla-cloud servers</p>
							</div>
						</div>
						<div className="interface-box">
							<Radio.Group
								onChange={this.handleChange}
								value={planType}
							>
								{planType !== 'basic'
									? (
										<div>
											<div className='unselect-basic-layout'></div>
											<Radio
												className={"in-active-menu"}
												value="basic"
											>
												<span className="form-label"><span>Cloud:</span>{" "}Basic</span>
												<div className={"flex-container"}>
													<div className="small-text">
														{/* <div>Get started fast with a basic exchange.</div> */}
														{/* <div>Comes with a built-in domain and hosting.</div> */}
														{/* <ul>
													<li>Cloud exchange server hosting</li>
													<li>Locallization</li>
													<li>Theme and color customization</li>
													<li>Community support</li>
												</ul> */}
													</div>
													{/*<div className="plan-detail-box">
												<Icon type="exclamation-circle" className="detail-icon" />
												<span>
													To select this option <Link onClick={() => moveToStep(3)}>go back</Link> and reconfigure your pairs.
												</span>
											</div>*/}
												</div>
											</Radio>
										</div>
									)
									: (
										<div className='selected-basic'>
											<div className='basic-layout'></div>
											<Radio value="basic" className="basic-plan">
												<span className="form-label"><span>Cloud:</span>{" "}Basic</span>
												<div className={"flex-container"}>
													<div className="small-text">
														<div>Get started fast with a basic exchange.</div>
														{/* <div>Comes with a built-in domain and hosting.</div> */}
														{/* <ul>
														<li>Cloud exchange server hosting</li>
														<li>Locallization</li>
														<li>Theme and color customization</li>
														<li>Community support</li>
													</ul> */}
														<Link onClick={this.handleViewConfigure}>View details</Link>
													</div>
													{/* <div>
													<img
														src={BASIC_COIN_DROP}
														alt="icon"
														className="candle-icon"
													/>
												</div> */}
												</div>
											</Radio>
										</div>
									)
								}
								{planType !== 'crypto'
									? (
										<div>
											<div className='unselect-crypto-layout'></div>
											<Radio
												className={"in-active-menu"}
												value="crypto"
											>
												<span className="form-label"><span>Cloud:</span>{" "}Crypto Pro</span>
												<div className={"flex-container"}>
													<div className="small-text">
														{/* <div>For those looking to start a crypto-to-crypto exchange business</div> */}
														{/* <div>Comes with one free custom coin and pair.</div> */}
														{/* <ul>
													<li>All feature in Basic</li>
													<li>Standard email support</li>
													<li>Custom domain</li>
													<li>Remove bitHolla branding</li>
													<li>Basic team management & access control</li>
												</ul> */}
													</div>
													{/*<div className="plan-detail-box">
												<Icon type="exclamation-circle" className="detail-icon" />
												<span>
													To select this option <Link onClick={() => moveToStep(3)}>go back</Link> and reconfigure your pairs.
												</span>
											</div>*/}
												</div>
											</Radio>
										</div>
									)
									: (
										<div className='selected-crypto'>
											<div className='crypto-layout'></div>
											<Radio value="crypto" className="crypto_pro-plan">
												<span className="form-label"><span>Cloud:</span>{" "}Crypto Pro<span className='greentxt'>{" "}(Recommended)</span></span>
												<div className={"flex-container"}>
													<div className="small-text">
														<div>For those looking to start a crypto-to-crypto exchange business</div>
														{/* <div>Comes with one free custom coin and pair.</div> */}
														{/* <ul>
													<li>All feature in Basic</li>
													<li>Standard email support</li>
													<li>Custom domain</li>
													<li>Chat</li>
													<li>Remove bitHolla branding</li>
													<li>Basic team management & access control</li>
												</ul> */}
														<Link onClick={this.handleViewConfigure}>View details</Link>
													</div>
													{/* <img
												src={STANDARD_COIN_DROP}
												alt="icon"
												className="candle-icon"
											/> */}
												</div>
											</Radio>
										</div>
									)
								}
								{planType !== 'fiat'
									? (
										<div>
											<div className='unselect-fiat-layout'></div>
											<Radio
												className={"in-active-menu"}
												value="fiat"
											>
												<span className="form-label"><span>Cloud:</span>{" "}Enterprise</span>
												<div className={"flex-container"}>
													<div className="small-text">
														{/* <div>
													For those that want to start a fiat to crypto exchange that have a bank or fiat payment processor
												</div> */}
														{/* <div>Includes one free custom coin and pair.</div> */}
														{/* <ul>
													<li>All feature in Standard</li>
													<li>Priority support and service</li>
													<li>Advance team management & access control</li>
													<li>Improved server reliability</li>
													<li>Server logs and backup</li>
													<li>Landing page</li>
													<li>Custom GitHub repo integration (required for code customization)</li>
												</ul> */}
													</div>
													{/*<div className="plan-detail-box">
												<Icon type="exclamation-circle" className="detail-icon" />
												<span>
													To select this option <Link onClick={() => moveToStep(3)}>go back</Link> and reconfigure your pairs.
												</span>
											</div>*/}
												</div>
											</Radio>
										</div>
									)
									: (
										<div className='selected-fiat'>
											<div className='fiat-layout'></div>
											<Radio value="fiat" className="fiat_master-plan">
												<span className="form-label"><span>Cloud:</span>{" "}Enterprise</span>
												<div className={"flex-container"}>
													<div className="small-text">
														<div>
															For those that want to have the ultimate exchange and unlock all the premium features
														</div>
														{/* <div>Includes one free custom coin and pair.</div> */}
														{/* <ul>
													<li>All feature in Standard</li>
													<li>Priority support and service</li>
													<li>Advance team management & access control</li>
													<li>Improved server reliability</li>
													<li>Server logs and backup</li>
													<li>Landing page</li>
													<li>Custom GitHub repo integration (required for code customization)</li>
												</ul> */}
														<Link onClick={this.handleViewConfigure}>View details</Link>
													</div>
													{/* <img
												src={PRO_COIN_DROP}
												alt="icon"
												className="candle-icon"
											/> */}
												</div>
											</Radio>
										</div>
									)
								}
							</Radio.Group>
						</div>
					</Item>
					<div className='smooth-drop'>
						<div className='animation-bounce'>
							<div className='align-center'>
								<div className='details-container' style={{ opacity: this.state.display_content }}>
									<div className='info-icon'>i</div>
									<div>Note: <span>All details can be changed at a later date</span></div>
								</div>
							</div>
							<Button
								block
								type="primary"
								style={{top:button_top}}
								onClick={(e) => {
									this.setState({
										type: 'Cloud',
										SERVER_TYPE: 'cloud',
									}, (e) => {
										this.handleExch(e)
									});
								}}
							>
								Select
							</Button>
						</div>
					</div>
					<div>
						{/* <div className="d-flex my-2">
							<div className="payment-mini-wrapper">
								<img src={ENTERPRISE_GREY_ICON} className="payment-mini-icon" alt="DIY" />
							</div>
							<span>
								Are you an established business? Complete the{' '}
								<Link onClick={() => this.setState({ is_enterprise: true })}>enterprise form.</Link>
							</span>
						</div> */}
						{/* <div className="d-flex my-2" style={{justifyContent:'center'}}>
							<span/>
							<span className='bottom-text'>
								Want to host your exchange yourself? Go with a{' '}
								<Link onClick={() => this.setState({ isTypeWarning: true })} className="link">On-Premise exchange.</Link>
							</span>
						</div> */}
					</div>
				</Form>
				: <ExchangeGuru 
						handleSuccess={this.handleSuccess}
					/>
				}
				<Modal
					width={isOpen ? '51rem' : '35rem'}
					visible={isTypeWarning || is_enterprise || isOpen || is_fiatConfirm}
					onCancel={this.onCancel}
					onOk={this.handleSubmit}
					className={is_enterprise || is_fiatConfirm ? "setupModal" : ""}
					title=""
					footer={null}
				>
					<ConfirmationWrapper>
						<ModalContent
							is_enterprise={is_enterprise}
							isTypeWarning={isTypeWarning}
							isPlanType={isOpen}
							isMonthly={isMonthly}
							priceData={priceData}
							handleToggle={this.handleToggle}
							onSubmitEnterprise={this.handleEnterprise}
							onCancel={this.onCancel}
							handleConfirm={this.handleConfirm}
						/>
					</ConfirmationWrapper>
				</Modal>
			</FormWrapper>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tech: state.setup.tech,
		biz: state.setup.biz,
		exchange: state.exchange[0],
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(SetupAction, dispatch),
	// setNewPay: bindActionCreators(BillingAction.setNewInvoice, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hosting);
